t = require('views/internal/teacup-with-helpers')('power_ups_voting_prefs')

module.exports = t.renderable ({ canChange, canSetObservers, canSetOrganization, canSetPublic, votingMode }) ->
  t.h4 ->
    t.format 'who-is-allowed-to-vote-on-cards'

  t.ul '.pop-over-list', ->

    t.li ->
      t.a '.js-voting-select', { href: '#', class: t.classify(disabled: !canChange), name: 'members' }, ->
        t.span '.name', ->
          t.format 'members'

        if votingMode == 'members'
          t.icon 'check'

        t.span '.sub-name', ->
          t.format 'available-on-all-boards'

    t.li ->
      t.a '.js-voting-select', { href: '#', class: t.classify(disabled: !canChange || !canSetObservers), name: 'observers' }, ->

        t.span '.name', ->
          t.format 'members-and-observers'

        if votingMode == 'observers'
          t.icon 'check'

        t.span '.sub-name', ->
          t.format 'available-only-on-boards-with-observers'

    t.li ->
      t.a '.js-voting-select', { href: '#', class: t.classify(disabled: !canChange || !canSetOrganization), name: 'org' }, ->

        t.span '.name', ->
          t.format 'organization-members'

        if votingMode == 'org'
          t.icon 'check'

        t.span '.sub-name', ->
          t.format 'available-only-on-boards-within-an-organization'

    t.li ->
      t.a '.js-voting-select', { href: '#', class: t.classify(disabled: !canChange || !canSetPublic), name: 'public' }, ->

        t.span '.name', ->
          t.format 'public-members'

        if votingMode == 'public'
          t.icon 'check'

        t.span '.sub-name', ->
          t.format 'available-on-public-boards'




// WEBPACK FOOTER //
// ./app/scripts/views/templates/power_ups_voting_prefs.coffee